/**
 * TDS Custom Mockup Integration v3
 * Hides the theme's product gallery and injects the mockup image directly.
 */
(function() {
  var params = new URLSearchParams(window.location.search);
  var mockupUrl = params.get('mockup');
  var idea = params.get('idea');
  var variantColor = params.get('variant_color');

  if (!mockupUrl || !window.location.pathname.includes('/products/custom-shirt')) return;

  // Inject CSS to hide original gallery and style our mockup
  var style = document.createElement('style');
  style.textContent = [
    '.product-media-gallery, [class*="media-gallery"], [class*="product-media"] { display: none !important; }',
    '.tds-custom-mockup { width: 100%; max-width: 600px; margin: 0 auto; }',
    '.tds-custom-mockup img { width: 100%; height: auto; border-radius: 8px; }'
  ].join('\n');
  document.head.appendChild(style);

  function init() {
    // Don't inject twice
    if (document.querySelector('.tds-custom-mockup')) return;

    // Find the product details / info section to insert before
    var detailsSection = document.querySelector(
      '[class*="product-details"], [class*="product-information"], .product__info-wrapper, [class*="product__details"]'
    );

    // Or find the main product section
    var productSection = document.querySelector(
      'section[class*="product"], .product-information, main'
    );

    var target = detailsSection || productSection;
    if (!target) return;

    // Create mockup container
    var container = document.createElement('div');
    container.className = 'tds-custom-mockup';
    var img = document.createElement('img');
    img.src = mockupUrl;
    img.alt = idea ? idea.toUpperCase() : 'Your custom shirt mockup';
    img.loading = 'eager';
    container.appendChild(img);

    // Insert before the details section, or at the start of the product section
    if (detailsSection && detailsSection.parentNode) {
      detailsSection.parentNode.insertBefore(container, detailsSection);
    } else if (target) {
      target.insertBefore(container, target.firstChild);
    }

    // Update product title
    if (idea) {
      var titles = document.querySelectorAll('h1');
      for (var i = 0; i < titles.length; i++) {
        var t = titles[i].textContent.trim().toLowerCase();
        if (t.includes('custom')) {
          titles[i].textContent = '"' + idea.toUpperCase() + '"';
          break;
        }
      }
    }

    // Pre-select color variant
    if (variantColor) {
      var colorMap = { black: 'Black', red: 'Red', charcoal: 'Charcoal' };
      var colorName = colorMap[variantColor] || variantColor;

      document.querySelectorAll('select').forEach(function(sel) {
        for (var j = 0; j < sel.options.length; j++) {
          if (sel.options[j].text.toLowerCase() === colorName.toLowerCase() ||
              sel.options[j].value.toLowerCase() === colorName.toLowerCase()) {
            sel.selectedIndex = j;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      });
    }

    // Inject line item properties into add-to-cart forms
    document.querySelectorAll('form[action*="/cart/add"], product-form form, form[data-type="add-to-cart-form"]').forEach(function(form) {
      if (!form.querySelector('input[name="properties[_mockup_url]"]')) {
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[_mockup_url]';
        inp.value = mockupUrl;
        form.appendChild(inp);
      }
      if (idea && !form.querySelector('input[name="properties[Custom Text]"]')) {
        var inp2 = document.createElement('input');
        inp2.type = 'hidden';
        inp2.name = 'properties[Custom Text]';
        inp2.value = idea;
        form.appendChild(inp2);
      }
    });
  }

  // Run on load and with retries
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 300);
  setTimeout(init, 800);
  setTimeout(init, 1500);
})();
